import { resolutions_template, bar_http_period } from "./param"
// import store from "./../../store/index"
// import { useChainId } from "lib/chains";
import {
	makeApiRequest,
	makeApiInitRequest,
} from './helpers.js';
import {
	subscribeOnStream,
	unsubscribeFromStream,
} from './streaming.js';
const lastBarsCache = new Map();
// 历史数据 第一条数据的 时间撮 因为k线图一次性历史数据只拿一部分，用户吧图往前滑动，就会用这个时间撮去请求更早的 历史数据
const detafeed_historyTime = 0
// 上一次的 K线周期 切换产品的时候 需要从websock 取消订阅这个
const detafeed_lastResolution = null
// 上一次的产品 切换产品的时候 需要从websock 取消订阅这个
const detafeed_lastSymbol = null
const configurationData = {
	locale: "zh",
	// supported_resolutions: ["1", "5", "15", "30", "60", "90", "240", "1D", "1W", "1M"],
	// supported_resolutions: ["1", "5", "15", "30", "60", "240", "1D", "1W", "1M"],
	supported_resolutions: ["1", "5", "15", "30", "60", "240", "1D"],
	exchanges: [{
		value: 'Bitfinex',
		name: 'Bitfinex',
		desc: 'Bitfinex',
	},
	{
		// `exchange` argument for the `searchSymbols` method, if a user selects this exchange
		value: 'Kraken',

		// filter name
		name: 'Kraken',

		// full exchange name displayed in the filter popup
		desc: 'Kraken bitcoin exchange',
	},
	],
	symbols_types: [{
		name: 'crypto',

		// `symbolType` argument for the `searchSymbols` method, if a user selects this symbol type
		value: 'crypto',
	},
		// ...
	],
};

async function getAllSymbols() {
	// const data = await makeApiRequest('data/v3/all/exchanges');
	// let allSymbols = [];

	// for (const exchange of configurationData.exchanges) {
	// 	const pairs = data.Data[exchange.value].pairs;

	// 	for (const leftPairPart of Object.keys(pairs)) {
	// 		const symbols = pairs[leftPairPart].map(rightPairPart => {
	// 			const symbol = generateSymbol(exchange.value, leftPairPart, rightPairPart);
	// 			return {
	// 				symbol: symbol.short,
	// 				full_name: symbol.full,
	// 				description: symbol.short,
	// 				exchange: exchange.value,
	// 				type: 'crypto',
	// 			};
	// 		});
	// 		allSymbols = [...allSymbols, ...symbols];
	// 	}
	// }
	// return allSymbols;
}

export default {
	onReady: (callback) => {
		// console.log('[onReady]: Method call');
		setTimeout(() => callback(configurationData));
	},

	searchSymbols: async (
		userInput,
		exchange,
		symbolType,
		onResultReadyCallback,
	) => {
		// console.log('[searchSymbols]: Method call');
		const symbols = await getAllSymbols();
		const newSymbols = symbols.filter(symbol => {
			const isExchangeValid = exchange === '' || symbol.exchange === exchange;
			const isFullSymbolContainsInput = symbol.full_name
				.toLowerCase()
				.indexOf(userInput.toLowerCase()) !== -1;
			return isExchangeValid && isFullSymbolContainsInput;
		});
		onResultReadyCallback(newSymbols);
	},

	resolveSymbol: async (
		symbolName,
		onSymbolResolvedCallback,
		onResolveErrorCallback,
	) => {
		// console.log('[resolveSymbol]: Method call', symbolName);
		const symbolItem ={
			full_name:symbolName,
			symbol: symbolName,
			description:"",
			type:"type",
			exchange:"",
		}
		const symbolInfo = {
			ticker: symbolItem.full_name,
			name: symbolItem.symbol,
			description: symbolItem.description,
			type: symbolItem.type,
			session: '24x7',
			timezone: 'Asia/Shanghai',
			exchange: symbolItem.exchange,
			minmov: 1,
			pricescale: 100000,
			has_intraday: true,
			has_daily: true,
			has_no_volume: true,
			has_weekly_and_monthly: true,
			supported_resolutions: configurationData.supported_resolutions,
			volume_precision: 2,
			data_status: 'streaming',
		};
		// console.log('[resolveSymbol]: Symbol resolved', symbolName);
		onSymbolResolvedCallback(symbolInfo);
	},

	getBars: async (symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) => {
		const { from, to, firstDataRequest } = periodParams;
		// console.log('[getBars]: Method call', symbolInfo, resolution, from, to, firstDataRequest);
		let lastBarsCache_key = symbolInfo.full_name + "~" +resolution;
		// console.log('[getBars]: lastBarsCache_key', lastBarsCache_key);
		// console.log('[getBars]: lastBarsCache', lastBarsCache);
		if (lastBarsCache.get(lastBarsCache_key) && !firstDataRequest) {
			onHistoryCallback([], {
				noData: true,
			});
			return;
		}
		let options = {
			symbol: symbolInfo.name,
			kType: resolutions_template[resolution] ?? "1day"
		}
		// let urlParameters = {
		// 	preferableChainId: 4002,
		// 	preferableSource: 'fast',
		// 	period: bar_http_period[resolution],
		// 	// to,
		// 	// from,
		// 	// limit: 300,
		// };
		// let symbol_name = symbolInfo.name.toLowerCase()
		// const query = Object.keys(urlParameters)
		// 	.map(name => `${name}=${encodeURIComponent(urlParameters[name])}`)
		// 	.join('&');
		// console.log("query=", query)
		try {
			// const datafeed_data = await makeApiRequest(`${symbol_name}?${query}`);
			const datafeed_data = await makeApiInitRequest(`kline/get300Kline`, options);
			// console.log("datafeed_data=", datafeed_data)
			if (!datafeed_data || datafeed_data.length <= 0) {
				// "noData" should be set if there is no data in the requested period.
				onHistoryCallback([], {
					noData: true,
				});
				return;
			}
			let bars = [];
			datafeed_data.forEach(bar => {
				// if (bar.t >= from && bar.t < to) {
				// 	bars = [...bars, {
				// 		time: bar.t * 1000,
				// 		low: bar.l,
				// 		high: bar.h,
				// 		open: bar.o,
				// 		close: bar.c,
				// 	}];
				// }
				// bars = [...bars, {
				// 	time: bar.t * 1000,
				// 	low: bar.l,
				// 	high: bar.h,
				// 	open: bar.o,
				// 	close: bar.c,
				// }];
				bars = [...bars, {
					time: bar.newId * 1000,
					low: bar.low,
					high: bar.high,
					open: bar.open,
					close: bar.close,
				}];
			});
			// bars = datafeed_data
			// console.log("bars=", bars)
			if (firstDataRequest && bars.length) {
				// console.log("firstDataRequest-存储首次历史数据")
				lastBarsCache.set(lastBarsCache_key, {
					...bars[bars.length - 1],
				});
				// console.log('[getBars]: lastBarsCache', lastBarsCache);
			}
			// lastBarsCache.set(lastBarsCache_key, {
			// 	...bars[bars.length - 1],
			// });
			// console.log(`[getBars]: returned ${bars.length} bar(s)`);
			if (bars.length) {
				onHistoryCallback(bars, {
					noData: false,
				});
			} else {
				onHistoryCallback([], {
					noData: true,
				});
			}
		} catch (error) {
			console.log('[getBars]: Get error', error);
			onErrorCallback(error);
		}
	},

	subscribeBars: (
		symbolInfo,
		resolution,
		onRealtimeCallback,
		subscribeUID,
		onResetCacheNeededCallback,
	) => {
		let lastBarsCache_key = symbolInfo.full_name + "~" +resolution;
		// console.log('[subscribeBars]: Method call with subscribeUID:', subscribeUID);
		// let lastBarsCache = store.state.conn.lastBarsCache;
		subscribeOnStream(
			symbolInfo,
			resolution,
			onRealtimeCallback,
			subscribeUID,
			onResetCacheNeededCallback,
			lastBarsCache.get(lastBarsCache_key),
		);
	},

	unsubscribeBars: (subscriberUID) => {
		// console.log('[unsubscribeBars]: Method call with subscriberUID:', subscriberUID);
		unsubscribeFromStream(subscriberUID);
	},
};
